export default __webpack_public_path__ + "75639d9098a7b8b036fbff1790fa9575.svg";